/* Keep the native dialog lifecycle, focus trap, search and scroll-unlock intact. */
(() => {
  const panel = document.getElementById('search-modal');
  if (!panel || panel.dataset.vicsSearchReady) return;
  panel.dataset.vicsSearchReady = 'true';
  const dialog = panel.querySelector('dialog');
  if (!dialog) return;
  let trigger;
  const position = () => {
    const viewport = window.visualViewport;
    const height = viewport?.height || window.innerHeight;
    const offset = viewport?.offsetTop || 0;
    const header = document.getElementById('header-component');
    const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    // When the on-screen keyboard opens, prioritise the input and result area.
    const keyboardOpen = height < window.innerHeight * 0.75;
    const top = keyboardOpen ? offset : Math.min(headerBottom, Math.max(0, height - 220)) + offset;
    panel.style.setProperty('--vics-search-top', `${Math.round(top)}px`);
    panel.style.setProperty('--vics-search-height', `${Math.max(120, Math.floor(height - (top - offset)))}px`);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[on\\:click="#search-modal/showDialog"]');
    if (button) { trigger = button; position(); }
  }, true);
  panel.addEventListener('dialog:open', () => {
    position();
    window.addEventListener('resize', position);
    window.visualViewport?.addEventListener('resize', position);
    window.visualViewport?.addEventListener('scroll', position);
  });
  panel.addEventListener('dialog:close', () => {
    window.removeEventListener('resize', position);
    window.visualViewport?.removeEventListener('resize', position);
    window.visualViewport?.removeEventListener('scroll', position);
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
  position();
})();
